module.exports = __webpack_public_path__ + "img/CM-PW-24-Kia-Lifestyle.4380922e.jpg";